<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="房间" required prop="roomCode" style="width:100%">
                <el-cascader
                    v-model="addForm.roomCode"
                    placeholder="请选择房间"
                    :options="listRoom" :props="props" style="width:100%"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="床位号" required prop="number">
                <el-input v-model="addForm.number"  placeholder="请输入床位"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Add',
  props: ["arr_ins"],
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',
        roomCode:'',
        number:'',
      },

      props: {
        emitPath:false,
        value: 'value',
        label: 'label',
        // 子层级字段名
        children: 'children'
      },

      listRoom:[],

      rules:{
        number:[
          { required: true, message: '请输入床位号', trigger: 'blur' },
        ],
        roomCode:[
          { required: true, message: '请选择房间', trigger: 'blur' },
        ]
      }


    }
  },

  methods: {
    init(){
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    insChange(val){
      this.addForm.institutionCode = val;

      this.listRoom = [];
      this.addForm.roomCode = '';
      this.getRoom();
    },

    getRoom(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Room/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.addForm.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var datas= response.data.data;

              var JSONData=JSON.stringify(datas);
              JSONData=JSONData.replace(/listRoomDTO/g,'children');
              JSONData=JSONData.replace(/name/g,'label');
              JSONData=JSONData.replace(/roomCode/g,'value');
              JSONData=JSONData.replace(/number/g,'label');
              this.listRoom = JSON.parse(JSONData);

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){
      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/GovAddIns",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>


</style>
